import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { TableSearchPanel } from 'ui/TableSearchPanel';
import { checkValue, formatDate, sortValue } from 'utils';
import { priceRender } from 'utils/table';

export const columns = [
  {
    title: 'Статья',
    dataIndex: 'name',
    key: 'name',
    fixed: 'left',
    width: '200px',
    render: checkValue,
    filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
      return (
        <TableSearchPanel>
          <Input
            autoFocus
            placeholder="Поиск по статье"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
          />
        </TableSearchPanel>
      );
    },
    filterIcon: () => <SearchOutlined />,
    onFilter: (value, record) => {
      return record.name.toLowerCase().includes(value.toLowerCase());
    },
  },
  {
    title: 'Ставка для работников',
    dataIndex: 'work_rate',
    key: 'work_rate',
    render: checkValue,
  },
  {
    title: 'Ставка для ИП',
    dataIndex: 'ip_rate',
    key: 'ip_rate',
    render: checkValue,
  },
  {
    title: 'База',
    dataIndex: 'base',
    key: 'base',
    render: priceRender,
    sorter: sortValue('base'),
  },
  {
    title: 'Макс',
    dataIndex: 'max_value',
    key: 'max_value',
    render: priceRender,
    sorter: sortValue('max_value'),
  },
  {
    title: 'Предельный доход налогооблажения',
    dataIndex: 'max_tax_income',
    key: 'max_tax_income',
    render: priceRender,
    sorter: sortValue('max_tax_income'),
  },
  {
    title: 'Объект налогоблажение с вычетом',
    dataIndex: 'tax_deducation',
    key: 'tax_deducation',
    render: priceRender,
    sorter: sortValue('tax_deducation'),
  },
  {
    title: 'Объект налогоблажение без  вычета',
    dataIndex: 'tax_without_deducation',
    key: 'tax_without_deducation',
    render: priceRender,
    sorter: sortValue('tax_without_deducation'),
  },
  {
    title: 'Дата начала',
    dataIndex: 'begin_date',
    key: 'begin_date',
    render: (date) => formatDate(date),
  },
  {
    title: 'Дата окончание',
    dataIndex: 'end_date',
    key: 'end_date',
    render: (date) => formatDate(date),
  },
];
